/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { AgentCardInfoWrapper } from './AgentCardInfoWrapper';
import { AgentCardNameWrapper } from './AgentCardNameWrapper';
import { AgentCardCredentialWrapper } from './AgentCardCredentialWrapper';
import { AgentCardDetailsWrapper } from './AgentCardDetailsWrapper';
import { AgentDetails, AssigneeDetails } from './AgentDetails/AgentDetails';
import { Card } from '@components/Card/Card';

export interface Assignee {
  fullName: string;
  credential?: {
    label: string;
    value: string;
  };
  details: AssigneeDetails;
}

export namespace AgentCard {
  export interface Props extends React.HTMLAttributes<HTMLDivElement> {
    assignee: Assignee;
  }
}

export const AgentCard: React.FC<AgentCard.Props> = ({ assignee }) => {
  const { details } = assignee;
  const showDetails = details.phoneNumber || details.email || details.website;

  return (
    <Card data-it="Agent-Card">
      {/* TODO: add avatar support */}
      <AgentCardInfoWrapper>
        <div>
          <AgentCardNameWrapper>{assignee.fullName}</AgentCardNameWrapper>
          {assignee.credential && (
            <AgentCardCredentialWrapper>
              {assignee.credential.label} {assignee.credential.value}
            </AgentCardCredentialWrapper>
          )}
        </div>
        <AgentCardDetailsWrapper>{showDetails && <AgentDetails details={details} />}</AgentCardDetailsWrapper>
      </AgentCardInfoWrapper>
    </Card>
  );
};
